module.exports = __webpack_public_path__ + "img/frame_typeib.a2653cf1.png";